import {AuthRedirectGuardMiddleware} from "gmjs";
import oidc from "@/oidc";

const authRedirectGuardMiddleware = AuthRedirectGuardMiddleware(oidc);

export default {
  data() {
    return {}
  },
  methods: {
    errorNotify: function (error) {
      let vue = this;
      return new Promise(function (resolve, reject) {
        if (error.response) {
          let status = error.response.status;
          switch (status) {
            case 401:
              vue.$error('Phiên đăng nhập đã hết hạn');
              try {
                authRedirectGuardMiddleware.run(vue.$router.currentRoute.fullPath, () => {
                })
              } catch (e) {
                // Handle exception here
                vue.$error(e)
              }
              break;
            case 403:
              vue.$forbidden();
              break;
            case 404:
              vue.$error("Không tìm thấy service.");
              break;
            case 502:
            case 503:
              vue.$error(`Không thể truy cập đến máy chủ.\nVui lòng thử lại sau ít phút hoặc liên hệ với quản trị viên để biết thêm chi tiết.`);
              break;
            default:
              resolve(error);
          }
        } else {
          resolve(error);
        }
      });
    }
  }
}